import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Award, Trophy, Diamond, User, Users, MapPin, Monitor } from 'lucide-react';

const PackagesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <main className="packages-page" data-testid="packages-page">
      <div className="packages-header">
        <h1>Choose Your <span className="gold">Coaching Package</span></h1>
        <p>
          Select the level of support that best fits your recovery journey. All packages 
          include professional sober coaching services tailored to your needs.
        </p>
        <div className="location-badges">
          <span className="location-badge">
            <MapPin size={16} style={{ display: 'inline', marginRight: '6px' }} />
            Premiere Sober Coaching Located in San Diego, California
          </span>
          <span className="location-badge">
            <Monitor size={16} style={{ display: 'inline', marginRight: '6px' }} />
            Sessions Offered Virtual and/or In-Person
          </span>
        </div>
      </div>

      <div className="packages-grid">
        {/* Silver Package */}
        <div className="package-card" data-testid="silver-package">
          <div className="package-icon silver">
            <Trophy size={48} />
          </div>
          <h3>SILVER</h3>
          <p className="package-subtitle">Stabilization & Accountability</p>
          <div className="package-price">
            <span className="amount">$500</span>
            <span className="period">/month</span>
          </div>
          <ul className="package-features">
            <li>1x weekly coaching session (60 min)</li>
            <li>Sobriety plan + routine building</li>
            <li>Relapse prevention tools</li>
            <li>2x weekly check-ins</li>
          </ul>
          <Link to="/payment?service=silver" className="package-btn orange" data-testid="silver-btn">
            Get Started
          </Link>
        </div>

        {/* Gold Package */}
        <div className="package-card popular" data-testid="gold-package">
          <span className="popular-badge">MOST POPULAR</span>
          <div className="package-icon gold">
            <Award size={48} />
          </div>
          <h3>GOLD</h3>
          <p className="package-subtitle">Integrated Recovery Coaching</p>
          <div className="package-price">
            <span className="amount">$850</span>
            <span className="period">/month</span>
          </div>
          <ul className="package-features">
            <li>1x weekly coaching session (60 min)</li>
            <li>1x biweekly check-in (30 min)</li>
            <li>Unlimited text support (business hours)</li>
            <li>Goal alignment (work, family, health)</li>
          </ul>
          <Link to="/payment?service=gold" className="package-btn cyan" data-testid="gold-btn">
            Get Started
          </Link>
        </div>

        {/* Platinum Package */}
        <div className="package-card" data-testid="platinum-package">
          <div className="package-icon platinum">
            <Diamond size={48} />
          </div>
          <h3>PLATINUM</h3>
          <p className="package-subtitle">High-Touch Sober Coaching</p>
          <div className="package-price">
            <span className="amount">$1,500</span>
            <span className="period">/month</span>
          </div>
          <ul className="package-features">
            <li>2x weekly coaching sessions (60 min)</li>
            <li>On-demand sober support (text/voice notes)</li>
            <li>Trigger & crisis response planning</li>
            <li>Identity + lifestyle redesign</li>
            <li>Concierge-level access</li>
          </ul>
          <Link to="/payment?service=platinum" className="package-btn pink" data-testid="platinum-btn">
            Get Started
          </Link>
        </div>
      </div>

      {/* A La Carte Section */}
      <section className="alacarte-section">
        <div className="alacarte-header">
          <h2>A La Carte Pricing</h2>
          <p>Flexible options for those seeking individual or family support sessions</p>
        </div>

        <div className="alacarte-grid">
          <div className="alacarte-card" data-testid="individual-session">
            <h3><User size={20} /> Individual Session</h3>
            <p className="subtitle"></p>
            <div className="price">$150 <span>/hour</span></div>
            <ul>
              <li>One-on-one personalized coaching</li>
              <li>Flexible scheduling</li>
              <li>Pay-per-session model</li>
            </ul>
            <Link to="/payment?service=individual" className="alacarte-btn cyan" data-testid="individual-btn">
              Book Session
            </Link>
          </div>

          <div className="alacarte-card" data-testid="couples-session">
            <h3><Users size={20} /> Couples/Family Session</h3>
            <p className="subtitle">Goals & Coaching Support</p>
            <div className="price">$200 <span>/hour</span></div>
            <ul>
              <li>Couples or family group coaching</li>
              <li>Relationship & boundary work</li>
              <li>Collaborative goal setting</li>
            </ul>
            <Link to="/payment?service=couples" className="alacarte-btn pink" data-testid="couples-btn">
              Book Session
            </Link>
          </div>
        </div>
      </section>

      {/* Consultation CTA */}
      <div className="consultation-cta" data-testid="consultation-cta">
        <h3>Not Sure Which <span>Package is Right for You?</span></h3>
        <p>
          Schedule a free consultation to discuss your needs and goals. I'll help you 
          choose the perfect coaching package for your recovery journey.
        </p>
        <button 
            type="button"
            className="btn-secondary" 
            data-testid="schedule-free-btn"
            onClick={() => window.open('https://calendly.com/drea-drdreasobercoaching/free-consultation-w-dr-drea', '_blank')}
          >
            Schedule Free Consultation
          </button>
      </div>
    </main>
  );
};

export default PackagesPage;
